import { render, staticRenderFns } from "./ZoopPagamento.vue?vue&type=template&id=80f31fd6&"
import script from "./ZoopPagamento.vue?vue&type=script&lang=js&"
export * from "./ZoopPagamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports